import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Loading";
import { PaginationLimit } from "../../Config";
import Config from "../../Config";
import { HiEye, HiOutlineDownload } from "react-icons/hi";
import { RiContactsFill, RiSendPlaneFill } from "react-icons/ri";
import { BsBellFill } from "react-icons/bs";
import { FaFileExport, FaUserNurse } from "react-icons/fa";
import {
  MdPayment,
  MdEdit,
  MdDelete,
  MdOutlineCloudUpload,
  MdOutlineCloudDownload,
} from "react-icons/md";

import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdPersonAddAlt1,
  MdModeEdit,
} from "react-icons/md";

const Table = ({
  ApiData,
  setSelectedItem,
  setOpenUpdateStatusModel,
  setOpenViewModel,
  makePaymentMutate,
  setOpenUploadCertificateModel,
  setOpenEditModel,
  generateCertificate,
  setOpenDeleteModel,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.UserReducer.user);

  const [data, setData] = useState([
    {
      assocName: "",
      email: "",
      status: "",
      typeOfReg: "",
      typeOfRegLabel: "",
      date: "",
    },
  ]);

  const openModel = (item) => {
    setOpenUpdateStatusModel(true);
    setSelectedItem(item);
  };

  const openViewModelHandler = (item) => {
    setSelectedItem(item);
    setOpenViewModel(true);
  };

  const edit = (item) => {
    navigate(`/edit-addressform/${item.id}`);
  };

  const uploadCertificate = (item) => {
    setSelectedItem(item);
    setOpenUploadCertificateModel(true);
  };

  // const generateCertificate = (item) => {
  //   setSelectedItem(item);
  //   generateCertificate(item);
  // }

  const makePayment = (item) => {
    setSelectedItem(item);
    //makePaymentModel(true);
    makePaymentMutate(item);
  };
  const deleteDevice = (item) => {
    setOpenDeleteModel(true);
    setSelectedItem(item);
  };

  const ActionBtnsTrash = (item) => {
    return (
      <ActionBtnWrapper>
        <Btn
          title="View All Details"
          onClick={() => openViewModelHandler(item)}
        >
          <HiEye className="text-gray-700" />
        </Btn>
        {user?.userType == 5 ? (
          item?.status == 10 ? (
            <>
              <Btn title="Edit Details" onClick={() => edit(item)}>
                <MdEdit className="text-gray-700" />
              </Btn>
              {/* <Btn title="Submit Document" onClick={() => uploaddocs(item)}>
          <MdOutlineCloudUpload className="text-gray-700" />
          </Btn>  */}
            </>
          ) : item?.status == 1 ? (
            <Btn title="Make Payment" onClick={() => makePayment(item)}>
              <MdPayment className="text-gray-700" />
            </Btn>
          ) : item?.status == 2 ? (
            <Btn title="Make Payment" onClick={() => makePayment(item)}>
              <MdPayment className="text-gray-700" />
            </Btn>
          ) : item?.status == 6 ? (
            <Link
              to={Config.docUrl + item.certificateName}
              target="_blank"
              download
            >
              <Btn title="Download Certificate">
                <MdOutlineCloudDownload className="text-gray-700" />
              </Btn>
            </Link>
          ) : (
            ""
          )
        ) : user?.userType == 3 ? (
          item?.status == 5 ? (
            <Btn
              title="Upload Certificate"
              onClick={() => uploadCertificate(item)}
            >
              <MdOutlineCloudUpload className="text-gray-700" />
            </Btn>
          ) : item?.status == 4 ? (
            <Btn title="Update Status" onClick={() => openModel(item)}>
              <MdEdit className="text-gray-700" />
            </Btn>
          ) : (
            ""
          )
        ) : user?.userType == 4 ? (
          item?.status == 5 ? (
            <Btn
              title="Upload Certificate"
              onClick={() => uploadCertificate(item)}
            >
              <MdOutlineCloudUpload className="text-gray-700" />
            </Btn>
          ) : item?.status == 2 ? ( // we will make 3 after payment module
            <Btn title="Update Status" onClick={() => openModel(item)}>
              <MdEdit className="text-gray-700" />
            </Btn>
          ) : (
            ""
          )
        ) : (
          <Btn title="Update Status" onClick={() => openModel(item)}>
            <MdEdit className="text-gray-700" />
          </Btn>
        )}
      </ActionBtnWrapper>
    );
  };

  const ActionBtns = (item) => {
    return (
      <ActionBtnWrapper>
        <Btn
          title="View All Details"
          onClick={() => openViewModelHandler(item)}
        >
          <HiEye className="text-gray-700" />
        </Btn>
        {/* {user?.userType == 4 && (item?.status == 2 || item?.status == 3 ) && //Status 2 become 3 after payment module
          <>
          <Btn title="Update Status" onClick={() => openModel(item)}>
          <MdEdit className="text-gray-700" />
          </Btn>
          </>
        } */}

        {user?.userType == 4 &&
          item?.status == 3 && ( //Status 2 become 3 after payment module
            <>
              <Btn title="Update Status" onClick={() => openModel(item)}>
                <MdEdit className="text-gray-700" />
              </Btn>
            </>
          )}

        {user?.userType == 3 && item?.status == 4 && (
          <>
            <Btn title="Update Status" onClick={() => openModel(item)}>
              <MdEdit className="text-gray-700" />
            </Btn>
          </>
        )}
        {/* {(user?.userType == 3) && (item?.status == 5) &&
          <>
           <Btn title="Generate Certificate" onClick={() => generateCertificate(item)}>
          <MdOutlineCloudUpload className="text-gray-700" /> 
          </Btn> 
          
          
          </>
        } */}
        {/* {(user?.userType == 3 || user?.userType == 4) && (item?.status == 6 || item?.status == 5) &&
          <>
          <Btn title="Upload Certificate" onClick={() => uploadCertificate(item)}>
          <MdOutlineCloudUpload className="text-gray-700" />
          </Btn>  
          </>
        } */}

        {user?.userType == 1 && (
          <>
            <Btn title="Update Status" onClick={() => openModel(item)}>
              <MdEdit className="text-gray-700" />
            </Btn>
          </>
        )}
        {user?.userType == 5 && item?.status == 10 && (
          <>
            <Btn title="Edit Details" onClick={() => edit(item)}>
              <MdEdit className="text-gray-700" />
            </Btn>
          </>
        )}
        {user?.userType == 5 && item?.status == 2 && (
          <>
            <Btn title="Make Payment" onClick={() => makePayment(item)}>
              <MdPayment className="text-gray-700" />
            </Btn>
          </>
        )}
        {user?.userType == 5 && item?.status == 3 && (
          <>
            <Btn title="Payment Details" onClick={() => makePayment(item)}>
              <MdPayment className="text-gray-700" />
            </Btn>
          </>
        )}

        {(user?.userType == 5 || user?.userType == 1) && item?.status == 6 && (
          <>
            <a
              href={Config.docUrl + item.certificateName}
              target="_blank"
              download
            >
              <Btn title="Download Certificate">
                <MdOutlineCloudDownload className="text-gray-700" />
              </Btn>
            </a>
          </>
        )}
        {user?.userType == 1 && (
          <>
            <Btn title="Remove User" onClick={() => deleteDevice(item)}>
              <MdDelete className="text-gray-700" />
            </Btn>
          </>
        )}
      </ActionBtnWrapper>
    );
  };

  const getStatus = (status) => {
    if (status == 1) {
      return <PendingBadge>{"Pending Payment"}</PendingBadge>;
    }
    if (status == 2) {
      return <PendingBadge>{"Pending Payment"}</PendingBadge>;
    }
    if (status == 3) {
      return <InprogressBadge>Inprogress</InprogressBadge>;
    }
    if (status == 4) {
      return <InprogressBadge>{"Approved By Asst"}</InprogressBadge>;
    }
    if (status == 5) {
      return <SuccessBadge>Completed</SuccessBadge>;
    }
    if (status == 6) {
      return <SuccessBadge>{"Certificate Issued"}</SuccessBadge>;
    }
    if (status == 7) {
      return <PendingBadge>{"Notice Issued"}</PendingBadge>;
    }
    if (status == 8) {
      return <ErrorBadge>{"Cancelled"}</ErrorBadge>;
    } else {
      return <ErrorBadge>Rejected</ErrorBadge>;
    }
  };

  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        assocName: item.assocName,
        id: item.id,
        date: moment(item.creationOn).format("DD-MM-YYYY hh:mm A"),
        articleNumber: item.articleNumber,
        establishmentDate: item.establishmentDate,
        oldAddress: item.oldAddress,
        newAddress: item.newAddress,
        // email: item.email,
        // reason: item.reason,
        status: getStatus(item.status),
        action: ActionBtns(item),
      }));

      setData(tempData);
    }
  }, [ApiData]);

  const columns = React.useMemo(() => {
    let cols = [
      {
        Header: "Assoc Name",
        accessor: "assocName",
      },
      {
        Header: "Establishment Date",
        accessor: "establishmentDate",
      },
      {
        Header: "Old Address",
        accessor: "oldAddress",
      },
      {
        Header: "New Address",
        accessor: "newAddress",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];

    return cols;
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setPageSize(PaginationLimit);
  }, []);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </CustomTable>

      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <select
            className="w-32 text-gray-500 text-sm"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[10, 50, 100].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show rows: {pageSize}
              </option>
            ))}
          </select>

          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <MdKeyboardArrowLeft className=" text-xl " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <MdKeyboardArrowRight className="text-xl " />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const EmailBtn = tw.button`cursor-pointer hover:text-blue-700 hover:underline `;

const UserImageWrapper = tw.div` flex items-center space-x-2`;
const UserImage = tw.img`w-5 h-5 rounded-full overflow-hidden`;

const ActionBtnWrapper = tw.div`flex items-center space-x-3`;

const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;

const CustomTable = tw.table` w-full`;
const Thead = tw.thead`border-b`;
const Tbody = tw.tbody`border-b`;
const Tr = tw.tr`border-b rounded-md overflow-hidden `;
const Th = tw.th`text-left text-sm p-3 font-medium text-gray-500  `;
const Td = tw.td`p-3 text-sm`;

const SuccessBadge = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-28 h-7 flex items-center justify-center rounded`;
const PendingBadge = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-28 h-7 flex items-center justify-center rounded`;
const InprogressBadge = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-28 h-7 flex items-center justify-center rounded`;
const ErrorBadge = tw.div`bg-red-300 text-white-700 text-xs border-red-300 border w-28 h-7 flex items-center justify-center rounded`;
export default Table;
